import HttpClient from "../httpClient";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";
import { StationParameterItem, StationParameterFilter } from "../../models/types/stationParameter";

class StationParameterService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<StationParameterFilter>): Promise<DefaultResponseContent<StationParameterItem[]>> {
        const response = await this.service.get<DefaultResponseContent<StationParameterItem[]>>("/admin/StationParameter/GetAll", requestData);
        return response;
    }

    async getLookup(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/StationParameter/GetLookup");
        return response;
    }

    async getStationParameterById(id: string): Promise<DefaultResponse<StationParameterItem>> {
        const response = await this.service.get<DefaultResponse<StationParameterItem>>(`/admin/StationParameter/GetDetail/${id}`);
        return response;
    }

    async createStationParameter(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/StationParameter/Create`, requestData);
        return response;
    }

    async updateStationParameter(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/StationParameter/Update`, requestData);
        return response;
    }

    async deleteStationParameter(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/StationParameter/Delete/${id}`);
        return response;
    }

}

const stationParameterSvc = new StationParameterService();
export default stationParameterSvc;
